export default __webpack_public_path__ + "static/media/logo.81547c12.png";